<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">参数设置</div>
      <el-form-item label="是否开启旺店通发货" prop="is_open">
        <el-switch v-model="form.is_open">
        </el-switch>
      </el-form-item>
      <el-form-item label="sid">
        <el-input v-model="form.sid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="appkey">
        <el-input v-model="form.appkey" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="appsecret">
        <el-input v-model="form.appsecret" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="shop_no">
        <el-input v-model="form.shop_no" class="max-w460"></el-input>
      </el-form-item>
      

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          is_open: '',
          sid: '',
          appkey: '',
          appsecret: '',
          shop_no: '',
        },
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.wangdiantongSetting({}, true)
          .then(data => {
            self.form = data.data.setting;
          })
          .catch(error => {});

      },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.saveWangdiantongSetting(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/wangdiantong/index.vue